// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__2Apls"};